import { QueryKey } from '@tanstack/react-query';
import { CubeQuery } from '@/types/cube';

export const VocCacheKeys = {
  all: ['voice-of-customer'] as const,
  getVocSurveyResponsesCount: (query: CubeQuery) => [...VocCacheKeys.all, 'get-voc-number-surveys', query] as QueryKey,
  getVocSurveyMetrics: (query: CubeQuery) => [...VocCacheKeys.all, 'get-voc-number-surveys-metrics', query] as const,
  getVocKeyMetricsTable: (query: CubeQuery) => [...VocCacheKeys.all, 'get-voc-key-metrics-table', query] as const,
  getVoCInteractionMetrics: (query: CubeQuery) =>
    [...VocCacheKeys.all, 'get-voc-interaction-metrics', query] as QueryKey,
  getVocCSATEvolutions: (query: CubeQuery) => [...VocCacheKeys.all, 'get-voc-csat-evolutions', query] as const,
  getVocEffortScoreEvolutions: (query: CubeQuery) =>
    [...VocCacheKeys.all, 'get-voc-effort-score-evolutions', query] as const,
  getVocTnpsEvolutions: (query: CubeQuery) => [...VocCacheKeys.all, 'get-voc-tnps-evolutions', query] as const,
  getVocCSATInsights: (query: CubeQuery, key: string) =>
    [...VocCacheKeys.all, `get-voc-sat-insights-${key}`, query] as const,
  getEmailVocInsights: (query: CubeQuery, key: string) =>
    [...VocCacheKeys.all, `get-voc-email-insights-${key}`, query] as const,
  getEventVocCustomQuestions: (query: CubeQuery, key: string) =>
    [...VocCacheKeys.all, `get-voc-event-custom-questions-${key}`, query] as const,
  getWebsiteVocInsights: (query: CubeQuery, key: string) =>
    [...VocCacheKeys.all, `get-voc-website-insights-${key}`, query] as const,
  getWebsiteVocCustomQuestions: (query: CubeQuery, key: string) =>
    [...VocCacheKeys.all, `get-voc-website-custom-questions-${key}`, query] as const,
  getFaceToFaceVocMetrics: (query: CubeQuery) => [...VocCacheKeys.all, `get-voc-face-to-face-insights`, query] as const,
  getEmailSatisfaction: (query: CubeQuery) => [...VocCacheKeys.all, 'get-voc-email-satisfaction', query] as const,
};
